import { Counter } from "@thilke/ui/components/counter";
import {
  Stat,
  StatDescription,
  StatIndicator,
  StatLabel,
  StatValue,
} from "@thilke/ui/components/ui/stat";
import { cn } from "@thilke/ui/lib/utils";
import type * as React from "react";

function MetricsOverviewBlock({
  className,
  ...props
}: React.ComponentProps<"section">) {
  return (
    <section
      data-slot="metrics-overview-block"
      className={cn(
        "grid gap-3 rounded-lg border bg-background p-4 md:grid-cols-3",
        className,
      )}
      {...props}
    >
      {[
        ["Sessions", "24", "up"],
        ["Active scenes", "7", "neutral"],
        ["Open issues", "3", "down"],
      ].map(([label, value, trend]) => (
        <Stat key={label}>
          <StatLabel>{label}</StatLabel>
          <StatValue>{value}</StatValue>
          <StatIndicator
            variant="badge"
            color={trend === "down" ? "warning" : "info"}
          >
            {trend}
          </StatIndicator>
          <StatDescription>
            devl.dev metrics-overview pattern adapted to @thilke/ui.
          </StatDescription>
        </Stat>
      ))}
      <div className="md:col-span-3">
        <Counter value={5} max={8} label="Milestone clock" tone="info" />
      </div>
    </section>
  );
}

export { MetricsOverviewBlock };
